import { render } from "./confirmUserInfo.vue?vue&type=template&id=47f71e62&scoped=true"
import script from "./confirmUserInfo.vue?vue&type=script&lang=js"
export * from "./confirmUserInfo.vue?vue&type=script&lang=js"

import "./confirmUserInfo.vue?vue&type=style&index=0&id=47f71e62&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f71e62"]])

export default __exports__